import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface JurisdictionFilterWarningDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  selectedJurisdictionsCount: number;
  recordType: "jurisdiction" | "user" | "question";
}

export function JurisdictionFilterWarningDialog({
  isOpen,
  onOpenChange,
  onConfirm,
  selectedJurisdictionsCount,
  recordType,
}: JurisdictionFilterWarningDialogProps) {
  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Jurisdiction Filter Active</AlertDialogTitle>
          <AlertDialogDescription>
            You currently have {selectedJurisdictionsCount} jurisdiction
            {selectedJurisdictionsCount !== 1 ? "s" : ""} selected in your
            filter. If you add a new {recordType}, it may not be visible in the
            current view until you update your filter settings.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            Continue Adding{" "}
            {recordType.charAt(0).toUpperCase() + recordType.slice(1)}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
